const SRC_SYSTEM = {
  //TOOD - Need to export as explicity constants
  DEFAULT_CHANNEL: 'Web',
  DEFAULT_EVENT_SOURCE: 'LightboxTW',
  IFRAME_ID: 'vcop-src-system-frame',
  IFRAME_NAME: 'VCOP SRC SYSTEM',
  IFRAME_WRAPPER_ID: 'vcop-src-sys',
  PATH: '/checkout-widget/vcop'
};

export default SRC_SYSTEM;
